import type { ActiveUsersAndResourcesMode, QueryFilters, QueryFiltersDomainOnly } from '../types';

export const authFirewallQueryKeys = {
    all: ['authFirewall'] as const,
    domains: () => [...authFirewallQueryKeys.all, 'domains'] as const,

    metrics: () => [...authFirewallQueryKeys.all, 'metrics'] as const,

    denyPolicies: () => [...authFirewallQueryKeys.metrics(), 'denyPolicies'] as const,

    protectedUsers: (filters: QueryFiltersDomainOnly) =>
        [...authFirewallQueryKeys.metrics(), 'protectedUsers', filters] as const,

    lastSync: () => [...authFirewallQueryKeys.metrics(), 'lastSync'] as const,

    configuration: () => [...authFirewallQueryKeys.all, 'configuration'] as const,

    authenticationDenyRate: (filters: QueryFilters) =>
        [...authFirewallQueryKeys.metrics(), 'authenticationDenyRate', filters] as const,

    authenticationsDenied: (filters: QueryFilters) =>
        [...authFirewallQueryKeys.metrics(), 'authenticationsDenied', filters] as const,

    authenticationTypeSummary: (filters: QueryFilters) =>
        [...authFirewallQueryKeys.all, 'authenticationTypeSummary', filters] as const,

    protocolTypeSummary: (filters: QueryFilters) =>
        [...authFirewallQueryKeys.all, 'protocolTypeSummary', filters] as const,

    policyType: () => [...authFirewallQueryKeys.metrics(), 'policyType'] as const,

    allAuthenticationsTraffic: (filters: QueryFilters) =>
        [...authFirewallQueryKeys.metrics(), 'allAuthenticationsTraffic', filters] as const,

    blockedAuthenticationsTraffic: (filters: QueryFilters) =>
        [...authFirewallQueryKeys.metrics(), 'blockedAuthenticationsTraffic', filters] as const,

    activeUsers: (filters: QueryFiltersDomainOnly, mode: ActiveUsersAndResourcesMode) =>
        [...authFirewallQueryKeys.metrics(), 'activeUsers', { ...filters, mode }] as const,

    activeResources: (filters: QueryFiltersDomainOnly, mode: ActiveUsersAndResourcesMode) =>
        [...authFirewallQueryKeys.metrics(), 'activeResources', filters, { mode }] as const,

    blockedResources: (filters: QueryFiltersDomainOnly, mode: ActiveUsersAndResourcesMode) =>
        [...authFirewallQueryKeys.metrics(), 'blockedResources', filters, { mode }] as const,

    blockedUsers: (filters: QueryFiltersDomainOnly, mode: ActiveUsersAndResourcesMode) =>
        [...authFirewallQueryKeys.metrics(), 'blockedUsers', filters, { mode }] as const,

    riskyUsers: (filters: QueryFiltersDomainOnly) =>
        [...authFirewallQueryKeys.metrics(), 'riskyUsers', filters] as const,

    riskyResources: (filters: QueryFiltersDomainOnly) =>
        [...authFirewallQueryKeys.metrics(), 'riskyResources', filters] as const,

    riskyIndicators: (filters: QueryFiltersDomainOnly) =>
        [...authFirewallQueryKeys.metrics(), 'riskyIndicators', filters] as const,

    insights: () => [...authFirewallQueryKeys.all, 'insights'] as const
} as const;
